import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface ImprovementRateProps {
  rate: number;
}

export const ImprovementRate: FC<ImprovementRateProps> = (props) => {
  const { rate } = props;
  const ratePercentage = Math.round(rate * 100);

  return (
    <span
      className={twMerge(
        "text-xs font-bold whitespace-nowrap",
        switchSign(rate, {
          negative: "text-destructive",
          zero: "text-gray-600",
          positive: "text-lime-600",
        }),
      )}
    >
      {switchSign(rate, {
        negative: "↓",
        zero: null,
        positive: "↑",
      })}
      {isFinite(rate) ? `${Math.abs(ratePercentage)}%` : "∞"}
    </span>
  );
};

function switchSign<T>(
  value: number,
  cases: {
    negative: T;
    zero: T;
    positive: T;
  },
): T {
  if (value < 0) {
    return cases.negative;
  } else if (value > 0) {
    return cases.positive;
  } else {
    return cases.zero;
  }
}
